/*
 * @Author: bbqin
 * @Date: 2023-02-14 13:47:46
 * @LastEditTime: 2023-07-24 13:59:30
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\components\wallet\index.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React, { Component, Fragment } from 'react';
import { isFunction, isBoolean } from '../../libs/utils';
import classNames from 'classnames';
import { Tooltip, Dropdown, Menu } from '@platform/base';
import AnimateRotateIcon from '../animation';
import {
    getMultiLang,
    getSysFieldid,
    getGlobalStorage,
} from '@platform/api';

require('./index.less');

/**
 * 创建单来源组件
 * @memberof SmartCard
 * @component Wallet
 * @property {boolean} [expanded = true] - 展开收起
 * @property {boolean} [forceRender = true] - 强制渲染
 * @property {boolean} [showArrow = true] - 展开收起图标
 * @property {function(): ReactNode} [headerRight = null] - 头部右侧区域
 * @property {function(): ReactNode} [headerCenter = null] - 头部中间区域
 * @property {function(expanded): null} [onExpand = null] - 展开事件
 * @property {string} [title = '默认标题'] - 头部标题
 * @property {string} [className = ''] - 扩展样式
 * @property {boolean} [visible = true] - 显隐性
 * @property {boolean} [forceVisible = true] - 强制显隐性
 * @property {boolean} [showHeader = true] - 头部显隐性
 * @property {boolean} [showFilter = false] - 过滤图标
 * @property {function(): null} [onFilter = null] - 过滤图标事件
 * @property {boolean} [showRefresh = true] - 刷新图标
 * @property {function(): null} [onRefresh = null] - 过滤图标事件
 * @property {boolean} [active = false] - 激活
 * @property {array} [iconList = []] - 右侧图标组,  [{ title: '测试1', iconName: 'fenxiang3', className: 'iconfont icon-icon-zhidan',  onClick: e => { console.log('测试1'); } }]
 * @property {number} [iconLimit = 2] - 图标组更多显示限制
 * @property {boolean} [collapseHideIcon = true] - 收起隐藏图标组
 */

const defaultProps = {
    prefixCls: 'card-wallet',
    name: 'CardWallet',
    // 展开收起
    expanded: true,
    // 默认展开
    defaultExpanded: true,
    // 强制渲染
    forceRender: true,
    // 展开收起图标
    showArrow: true,
    // 头部右侧区域
    headerRight: null,
    // 头部中间区域
    headerCenter: null,
    onChange: null, // 准备弃用  勿用  使用onExpand代替
    // 展开事件
    onExpand: null,
    title: '默认标题',
    // 扩展样式
    className: '',
    // 显隐性
    visible: true,
    // 强制显隐性
    forceVisible: true,
    // 头部显隐性
    showHeader: true,
    // 过滤图标
    showFilter: false,
    // 过滤图标事件
    onFilter: null,
    // 刷新图标
    showRefresh: true,
    // 刷新图标事件
    onRefresh: null,
    // 激活
    active: false,
    // 右侧图标组
    iconList: [],
    // 图标组更多显示限制
    iconLimit: 2,
    // 收起隐藏图标组
    collapseHideIcon: true,
    // 自动化
    fieldid: 'smart_card_wallet',
};

class CardWallet extends Component {
    constructor(props) {
        super(props);
        this.state = { expanded: isBoolean(props.expanded) ? props.expanded : props.defaultExpanded };
    }

    componentDidMount() {
        //调用多语
        let callback = json => {
            this.setState({ langJson: json });
        };
        getMultiLang({ moduleId: "containers_smart_card", callback });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.expanded !== nextProps.expanded) {
            this.setState({ expanded: nextProps.expanded });
        }
    }

    onClick = () => {
        const { onChange, onExpand } = this.props;
        const { expanded } = this.state;
        this.setState({ expanded: !expanded }, () => {
            isFunction(onChange) && onChange(!expanded);
            isFunction(onExpand) && onExpand(!expanded);
        });
    }

    getIconList = () => {
        const {
            showFilter,
            onFilter,
            showRefresh,
            onRefresh,
            iconList = [],
            iconLimit,
            prefixCls,
        } = this.props;

        const { langJson = {} } = this.state;

        let currentLimit = iconLimit;
        if (showRefresh) {
            currentLimit--;
        }
        if (showFilter) {
            currentLimit--;
        }

        const fixedIcon = [];
        const moreList = [];
        iconList.forEach((element, index) => {
            if (index < currentLimit) {
                fixedIcon.push(element);
            } else {
                moreList.push(element);
            }
        });

        let more = null;
        if (moreList.length) {
            more = <Dropdown
                trigger={['click', 'hover']}
                placement="bottomRight"
                overlay={<div
                    className={`${prefixCls}-icon-overlay`}
                    onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                    }}
                >
                    <div
                        className={`${prefixCls}-icon-menu`}
                    >
                        {iconList.map((icon, index) => {
                            const { title, iconName, className, onClick } = icon;
                            return <div key={index} className={`${prefixCls}-icon-menu-item`}
                                onClick={e => {
                                    isFunction(onClick) && onClick(e);
                                }}
                            >
                                <i
                                    title={title}
                                    className={className ? className : `iconfont icon-${iconName}`}
                                />
                                <div className={`${prefixCls}-icon-menu-item-content`} title={title}>{title}</div>
                            </div>;
                        })}
                    </div>
                </div>}
                animation="slide-up"
                // getPopupContainer={() => {
                //     return document.body;
                // }}
            >
                <AnimateRotateIcon className='iconfont icon-gengduo2' />
            </Dropdown>;
        }

        return <Fragment>
            {showFilter && <AnimateRotateIcon
                className='iconfont icon-shaixuan-xiao'
                title={langJson['card-wallet-icon-filter']}
                onClick={e => {
                    isFunction(onFilter) && onFilter(e);
                }}
            />}
            {showRefresh && <AnimateRotateIcon
                animation
                className={`iconfont icon-shuaxin1`}
                title={langJson['card-wallet-icon-refresh']}
                onClick={e => {
                    isFunction(onRefresh) && onRefresh(e);
                }}
            />}
            {fixedIcon.map((icon, index) => {
                const { title, iconName, className, onClick } = icon;
                return <AnimateRotateIcon
                    key={index}
                    title={title}
                    className={className ? className : `iconfont icon-${iconName}`}
                    onClick={e => {
                        isFunction(onClick) && onClick(e);
                    }}
                />;
            })}
            {more}
        </Fragment>;
    }

    render() {

        const {
            prefixCls,
            className,
            headerRight,
            children,
            showArrow,
            title,
            headerCenter,
            forceRender,
            visible,
            forceVisible,
            showHeader,
            showFilter,
            onFilter,
            showRefresh,
            onRefresh,
            active,
            onActive,
            connectDragSource,
            collapseHideIcon,
            fieldid,
            _design,
        } = this.props;

        if (!visible && forceVisible) {
            return null;
        }

        const { expanded } = this.state;

        let childrenDom = children;
        if (_design) {
            childrenDom = React.cloneElement(children, {
                children: Array.isArray(children.props.children) && React.Children.map(children.props.children, c => {
                    return React.cloneElement(c, { props: { ...c?.props?.props || {}, getParentPageInstance: () => { return c.props.pageScope.props; } } });
                }),
            });
        }
        if (!expanded && !forceRender) {
            // 不显示时，是否还有dom
            childrenDom = null;
        }

        const header = <div className={`${prefixCls}-header  ${showHeader ? 'header-show' : 'header-hidden'}`} fieldid={getSysFieldid(`${fieldid}_header`)}>
            <div className={`${prefixCls}-header-left`} onClick={this.onClick}>
                {showArrow && <i className='iconfont icon-ywzs-zhankai' />}
                <div className={`${prefixCls}-header-title`} title={title}>{title}</div>
            </div>
            <div className={`${prefixCls}-header-center`} >
                {isFunction(headerCenter) ? headerCenter() : null}
            </div>
            <div className={`${prefixCls}-header-right`}>
                {isFunction(headerRight) ? headerRight() : null}
                <div className={`${prefixCls}-header-right-icon  ${collapseHideIcon && !expanded ? 'right-icon-hidden' : ''}`}>
                    {this.getIconList()}
                </div>
            </div>
        </div>;
        return <div
            className={classNames(`${prefixCls}-wrapper ${className}`, {
                active: active,
                [`${prefixCls}-expanded`]: expanded,
                [`${prefixCls}-collapse`]: !expanded,
                [`${prefixCls}-hidden`]: !visible,
            })}
            onClick={e => {
                isFunction(onActive) && onActive(e);
            }}
            fieldid={getSysFieldid(`${fieldid}`)}
        >
            {connectDragSource ? connectDragSource(header) : header}
            <div
                className={`${prefixCls}-body ${prefixCls}-body-${expanded ? 'expanded' : 'collapse'} `}
                fieldid={getSysFieldid(`${fieldid}_body`)}
            >{childrenDom}</div>
        </div>;
    }
}

CardWallet.defaultProps = defaultProps;
CardWallet.displayName = 'CardWallet';

export default CardWallet;
